import AppDispatcher from '../dispatcher/AppDispatcher';
import FinancialStoriesConstants from '../constants/FinancialStoriesConstants';
import FinancialStoriesParser from '../parsers/FinancialStoriesParser';
import AccountParser from '../parsers/AccountParser';

class FinancialStoriesActionCreator {
  setTileType(tileType) {
    AppDispatcher.handleViewAction({
      actionType: FinancialStoriesConstants.SET_TILETYPE,
      tileType,
    });
  }

  /* API Call to fetch all FS Stories */
  getFSConnection(account) {
    AppDispatcher.handleViewAction({
      actionType:
        FinancialStoriesConstants.FINANCIAL_STORIES_CONNECTION_REQUEST,
      accountId: account,
    });
  }

  /* API call to fetch  micro transactions */
  getMicroTransactions(account, month, count) {
    AppDispatcher.handleViewAction({
      actionType: FinancialStoriesConstants.MICRO_TRANSACTION_REQUEST,
      accountId: account,
      month,
      count,
    });
  }

  /* API call to fetch  insAndOuts transactions */
  getInsAndOuts(account, month, count) {
    AppDispatcher.handleViewAction({
      actionType: FinancialStoriesConstants.IN_OUT_REQUEST,
      accountId: account,
      month,
      count,
    });
  }

  /* API call to fetch  cashpoint transactions */
  getCashpoint(account, month, count) {
    AppDispatcher.handleViewAction({
      actionType: FinancialStoriesConstants.CASHPOINT_REQUEST,
      accountId: account,
      month,
      count,
    });
  }

  resetErrorFlag() {
    AppDispatcher.handleViewAction({
      actionType: FinancialStoriesConstants.RESET_ERROR_FLAG,
    });
  }

  /*
   ** Server Actions
   */
  handleFinancialStoriesConnectionSuccess(
    type,
    response,
    accountId,
    month,
    updateQuery
  ) {
    const fsData = FinancialStoriesParser.parseFinancialStoriesResponse(
      type,
      response,
      accountId
    );
    AppDispatcher.handleServerAction({
      actionType:
        FinancialStoriesConstants.FINANCIAL_STORIES_CONNECTION_SUCCESS,
      fsData,
      tileType: type,
      accountId,
      month,
      updateQuery,
    });
  }

  handleFinancialStoriesConnectionError(error, type, updateQuery) {
    const accParser = new AccountParser();
    const errorData = accParser.parseListErrorHandler(error);
    AppDispatcher.handleServerAction({
      actionType: FinancialStoriesConstants.FINANCIAL_STORIES_CONNECTION_ERROR,
      error: errorData,
      type,
      updateQuery,
    });
  }
}

export default new FinancialStoriesActionCreator();
